import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const category = async (id?: number) => axios.get(Routes.CATEGORY + "/" + id);

export const useCategory = (id?: number) =>
  useQuery({
    queryKey: [Keys.CATEGORY_QRY, id],
    queryFn: () => category(id),
    enabled: id ? true : false,
  });
